import {
  FrontendPlugin,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import SpeedIcon from '@material-ui/icons/Speed';

import { rootRouteRef } from './routes';

const perflabViewerPage = PageBlueprint.make({
  name: 'perflab-viewer',
  params: {
    path: '/perflab',
    title: 'Perflab Viewer',
    icon: <SpeedIcon />,
    routeRef: rootRouteRef,
    // The viewer brings its own breadcrumbs, title bar and navigation rail, so
    // the default plugin header would only duplicate them. Dropping it also
    // means `Page`'s `height: 100vh` matches the space actually available.
    noHeader: true,
    loader: () =>
      import('./components/PerflabViewerPage').then(m => (
        <m.PerflabViewerPage />
      )),
  },
});

const perflabViewerLegacyPage = PageBlueprint.make({
  name: 'perflab-viewer-legacy-redirect',
  params: {
    path: '/perflab-viewer',
    title: 'Perflab Viewer',
    icon: <SpeedIcon />,
    loader: () =>
      import('./components/LegacyPerflabRedirect').then(m => (
        <m.LegacyPerflabRedirect />
      )),
  },
});

const perflabViewerPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'perflab',
  routes: { root: rootRouteRef },
  extensions: [perflabViewerPage, perflabViewerLegacyPage],
});

export default perflabViewerPlugin;
